import { render, staticRenderFns } from "./AdminCompanyCreateView.vue?vue&type=template&id=16b6c182&"
import script from "./AdminCompanyCreateView.vue?vue&type=script&lang=js&"
export * from "./AdminCompanyCreateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports